import { createSlice } from "@reduxjs/toolkit";

const SalonSlice = createSlice({
  name: "Salon",
  initialState: {
    step1: [],
    step2: [],
    step25: "",
    step3: [],
    step4: [],
    step5: [],
  },
  reducers: {
    updateField: (state, action) => {
      const { field, value } = action.payload;
      if (field.includes(".")) {
        const fields = field.split(".");
        let nestedState = state;
        for (let i = 0; i < fields.length - 1; i++) {
          nestedState = nestedState[fields[i]];
        }
        nestedState[fields[fields.length - 1]] = value;
      } else {
        state[field] = value;
      }
    },
    updateStep1: (state, action) => {
      state.step1 = action.payload;
    },
    updateStep2: (state, action) => {
      state.step2 = action.payload;
    },
    updateStep25: (state, action) => {
      state.step25 = action.payload;
    },
    updateStep3: (state, action) => {
      state.step3 = action.payload;
    },
    updateStep4: (state, action) => {
      state.step4 = action.payload;
    },
    updateStep5: (state, action) => {
      state.step5 = action.payload;
    },
    emptyStep: (state, action) => {
      state.step1 = [];
      state.step2 = [];
      state.step25 = "";
      state.step3 = [];
      state.step4 = [];
      state.step5 = [];
    },
  },
});

export const {
  updateField,
  updateStep1,
  updateStep2,
  updateStep25,
  updateStep3,
  updateStep4,
  updateStep5,
  emptyStep,
} = SalonSlice.actions;
export default SalonSlice.reducer;
